// extracted by mini-css-extract-plugin
export var downArrow = "_9m-0";
export var label = "_9m-1";
export var treatmentCard = "_9m-3";
export var upArrow = "_9m-2";